/**
 * Steps in the two-step login flow. Step 1 collects the email and asks
 * POST /auth/discover how to authenticate this user; step 2 is only reached
 * when the answer is password auth. The oidc and saml answers redirect the
 * browser away instead of advancing the step.
 */
export const AUTH_STEPS = {
  EMAIL: 'email',
  PASSWORD: 'password',
};

/**
 * Values POST /auth/discover can return in `next`. Anything unrecognized is
 * treated as PASSWORD so a backend that learns a new route cannot dead-end an
 * older frontend.
 */
export const DISCOVER_NEXT = {
  PASSWORD: 'password',
  OIDC: 'oidc',
  SAML: 'saml',
};
